class Controller {
  constructor($mdDialog, locals) {
    "ngInject";

    this.message = locals.message;
    this.$mdDialog = $mdDialog;
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    if (this.note) {
      this.$mdDialog.hide({ note: this.note });
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/actionListTable/invoiceItemDialog/invoiceItemDialog.controller.js